/**
 * Function updates single betslip object with 'betslip update' object from push message
 *
 * @param betslip Betslip object as stored in reframe DB (It is structured the same for mobile and portal)
 * @param betslipUpdate Object with updated info for single betslip from push message received on web socket
 * @returns Betslip object updated with data from betslipUpdate
 */
export function updateBetslipWithPushMessage(betslip, betslipUpdate) {
    return betslip
        .update('groups', groups =>
            groups.map(group =>
                group.update('picks', picks =>
                    picks.map(pick => {
                        const updatedPick = betslipUpdate
                            .get('updatedPicks')
                            .find(up => up.get('betId') === pick.get('betId'));

                        if (updatedPick) {
                            return pick.set('odds', updatedPick.get('odds'));
                        }

                        return pick;
                    })
                )
            )
        )
        .set('errors', betslipUpdate.get('errors'))
        .set('submit', betslipUpdate.get('submit'));
}
